import api from './api';

const walletService = {
  getBalance: () => api.get('/wallet/balance'),

  getTransactions: (params = {}) => api.get('/wallet/transactions', { params }),

  initiateRecharge: (amount, currency = 'INR', idempotencyKey) =>
    api.post(
      '/wallet/recharge',
      { amount, currency },
      { headers: { 'X-Idempotency-Key': idempotencyKey } }
    ),

  verifyRecharge: (paymentData, idempotencyKey) =>
    api.post('/wallet/recharge/verify', paymentData, {
      headers: { 'X-Idempotency-Key': idempotencyKey },
    }),

  recoverPending: () => api.post('/wallet/recharge/recover'),

  requestWithdrawal: (amount, bankAccountId, paymentMethodId, idempotencyKey) =>
    api.post(
      '/wallet/withdraw',
      { amount, bank_account_id: bankAccountId || 0, payment_method_id: paymentMethodId || 0 },
      { headers: { 'X-Idempotency-Key': idempotencyKey } }
    ),

  getWithdrawals: () => api.get('/wallet/withdrawals'),

  requestRefund: (amount, reason, idempotencyKey) =>
    api.post(
      '/wallet/refund',
      { amount, reason },
      { headers: { 'X-Idempotency-Key': idempotencyKey } }
    ),

  addBankAccount: (data) => api.post('/wallet/bank-accounts', data),

  getBankAccounts: () => api.get('/wallet/bank-accounts'),

  deleteBankAccount: (id) => api.delete(`/wallet/bank-accounts/${id}`),

  // Payout-side UPI methods (for astrologer payouts, NOT consumer-side /wallet/upi)
  addPayoutUPI: (data) => api.post('/wallet/payout-methods/upi', data),
  getPayoutUPIMethods: () => api.get('/wallet/payout-methods/upi'),

  // Admin endpoints
  getPendingWithdrawals: (params = {}) =>
    api.get('/admin/withdrawals/pending', { params }),

  approveWithdrawal: (id) =>
    api.post(`/admin/withdrawals/${id}/approve`),

  rejectWithdrawal: (id, reason) =>
    api.post(`/admin/withdrawals/${id}/reject`, { reason }),

  getAdminStats: () => api.get('/admin/wallet/stats'),

  // Astrologer earnings
  getEarningsSummary: () => api.get('/astrologer/earnings/summary'),
  getEarningsHistory: (params = {}) => api.get('/astrologer/earnings/history', { params }),
  updatePAN: (panNumber) => api.put('/astrologer/pan', { pan_number: panNumber }),
  getPayoutPreview: (amount) => api.get('/astrologer/payout/preview', { params: { amount } }),
  getPayoutEligibility: () => api.get('/astrologer/payout/eligibility'),

  // Admin earnings & payouts
  getAdminAllPayouts: (params = {}) => api.get('/admin/payouts', { params }),
  getAstrologerEarningsList: (params = {}) => api.get('/admin/astrologers/earnings', { params }),
  getAdminRevenueSummary: (params = {}) => api.get('/admin/dashboard/summary', { params }),
  getActiveConsultations: () => api.get('/admin/consultations/active'),
};

export default walletService;
